export const ADDRESSSCHANGES = 'md_addressChanges_GLOBAL';